import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Avatar, AvatarFallback, AvatarImage, ComboboxOptionRenderProps } from "@tellescope/ui";
import { formatInitials, formatName, formatPhone } from "@tellescope/utils";

export interface InboxSMSRecipientItemProps extends ComboboxOptionRenderProps<string> {
  enduser?: TellescopeModelFromName<"endusers">;
}

export const InboxSMSRecipientItem = ({ option: { value }, enduser }: InboxSMSRecipientItemProps) => {
  return (
    <div className="flex gap-2 items-center">
      {!!enduser && (
        <Avatar>
          <AvatarImage src={enduser.avatar} />
          <AvatarFallback>{formatInitials(enduser)}</AvatarFallback>
        </Avatar>
      )}
      <div className="flex flex-col">
        {!!enduser && <p className="font-semibold">{formatName(enduser)}</p>}
        <p className={enduser ? "text-muted-foreground" : "font-semibold"}>{formatPhone(enduser?.phone ?? value)}</p>
      </div>
    </div>
  );
};
